import React from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";

// Custom.
import Header from "../Header";
import { ContentProps } from "../global";

const Content: React.FC<ContentProps> = (props) => {
  const { data, error, loading, HeaderProps, children } = props;

  return (
    <Box className="vo-global__top-bottom-space">
      <Header {...HeaderProps} />
      {error && (
        <Box sx={{ mt: 4 }}>
          <Alert severity="error">{JSON.stringify(error)}</Alert>
        </Box>
      )}
      {(loading || data) && !error && (
        <Box
          sx={(theme) => ({
            border: `1px solid ${theme.palette.grey[100]}`,
            borderRadius: 1,
            margin: "0 auto",
            maxWidth: 700,
            mt: 4,
            padding: 2,
          })}
        >
          {loading && (
            <>
              {[1, 2, 3, 4].map((v: number) => (
                <Skeleton key={v} height={50} />
              ))}
            </>
          )}
          {!loading && (
            <Stack
              spacing={1}
              sx={(theme) => ({
                "& .MuiBox-root": {
                  borderTop: `1px solid ${theme.palette.grey[100]}`,
                  pt: 1,
                  "&:first-child": {
                    borderTop: "none",
                    pt: 0,
                  },
                },
              })}
            >
              {children}
            </Stack>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Content;
